import { PAGE_FOR_AD_UNIT_TRANSFER_LIST_FRAGMENT } from 'features/inventory/api/fragments/pageForAdUnitTransferList'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_PAGES_FOR_AD_UNIT_TRANSFER_LIST: TypedDocumentNode<Data, Variables> = gql`
  ${PAGE_FOR_AD_UNIT_TRANSFER_LIST_FRAGMENT}

  query pagesForTransferList($domainId: ID!, $workspaceId: ID!) {
    pages(domainId: $domainId, workspaceId: $workspaceId) {
      nodes {
        ...PageForAdUnitTransferList
      }
    }
  }
`
